import React, { useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logo from '../../../assets/img/Sculpt-logo.png';
import { useDispatch, useSelector } from 'react-redux';
import { appointementGetById, viewLead } from '../../../redux/actions/Files.action';
import { medicinePrint } from '../../../redux/actions/Doctor.action';

const MedicineBill = ({ billRef }) => {
    const { id } = useParams();

    const dispatch = useDispatch();
    const branchData = useSelector((state) => state.files);

    const medicinedata = useSelector((state) => state.doctor);   

    const medicine = JSON.parse(localStorage.getItem('selectedPackage1'))
    const patientIds = localStorage.getItem('patientIds')
    const userId = branchData?.getAppointmentById?.data?.appointmentData?.patientId;
    const userData = medicinedata?.medicinePrint?.data?.patientData

    const authName = medicinedata?.medicinePrint?.data?.addedByName

    useEffect(() => {
        if (id) {
            dispatch(appointementGetById(id));
        }
        dispatch(viewLead(patientIds))
        dispatch(medicinePrint(patientIds, medicine))
    }, [id, userId]);

    // const downloadPdf = () => {
    //     html2canvas(billRef.current, { scale: 2 }).then(canvas => {
    //         const imgData = canvas.toDataURL('image/png');
    //         const pdf = new jsPDF('p', 'pt', 'a4');

    //         const pageWidth = pdf.internal.pageSize.getWidth();
    //         const pageHeight = pdf.internal.pageSize.getHeight();

    //         const imgWidth = pageWidth;
    //         const imgHeight = (canvas.height * imgWidth) / canvas.width;

    //         if (imgHeight > pageHeight) {
    //             const scaleFactor = pageHeight / imgHeight;
    //             pdf.addImage(imgData, 'PNG', 0, 0, imgWidth * scaleFactor, pageHeight);
    //         } else {
    //             pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
    //         }

    //         pdf.save('Medicine.pdf');
    //     });
    // };

    const getCurrentDate = () => {
        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day} / ${month} / ${year}`;
    };

    const capitalizeFirstLetter = (string) => {
        if (!string) return "";
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    };

    return (
        <div className='d-none'>
            {/* <div className='text-center'>
                <button onClick={downloadPdf} className='px-4 py-2 bg-theme-dark text-white my-3 rounded-lg'>Download</button>
            </div> */}

            <div
                ref={billRef}
                style={{
                    fontFamily: "Arial, sans-serif",
                    // backgroundColor: "#fff",
                    // width: '100%',
                    // maxWidth: '595pt',
                    // minHeight: "842pt",
                    // height: 'auto',
                    // overflow: 'hidden',
                    // boxSizing: 'border-box',
                    // margin: 'auto',
                    position: 'relative'
                }}
            >
                <div
                    style={{
                        width: "100%",
                        // borderBottom: "2px solid black",
                        paddingBottom: "10px",
                        padding: "10mm",
                    }}
                >
                    <div style={{ marginBottom: "10px", height: "100px" }}>
                        {/* <img src={logo} alt="Sculpt logo" style={{ height: "100px" }} /> */}
                    </div>
                </div>

                <div
                    style={{
                        display: "flex",
                        marginTop: "20px",
                        gap: '10px',
                        padding: "10mm",
                    }}
                >
                    <div style={{ width: '75%' }}>
                        <div style={{
                            width: "100%",
                            fontSize: "12px",
                            marginTop: '10px'
                        }}>

                            <p><strong>Branch : </strong> {userData?.branch}</p>
                            <p><strong>Address : </strong> {branchData?.getAppointmentById?.data?.appointmentData?.branchAddress}</p>
                            <p><strong>Dr. Name : </strong> {authName}</p>
                            <hr style={{ color: "#b78234", fontWeight: "bold" }} />
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    <p><strong>Date : </strong>{getCurrentDate()}</p>
                                    <p><strong>Patient Name : </strong> {userData?.fname} {userData?.lname}</p>
                                </div>
                                <div>
                                    <p><strong>Sex : </strong> {userData?.gender}</p>
                                    <p><strong>State : </strong> {userData?.state || '-'}</p>
                                </div>
                                <div>
                                    <p><strong>Contact No : </strong> {userData?.phoneNumber}</p>
                                    <p><strong>Ref By : </strong>  {userData?.reference[0]?.doctorDetail || userData?.reference[0]?.personDetail || ' - '}</p>
                                </div>
                            </div>
                        </div>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />

                        <div style={{ width: "100%", height: 'calc(80vh - 60px)' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '10px', textAlign: 'center', fontSize: "12px" }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid gray', padding: '5px', minWidth: '50px' }}>SR. NO</th>
                                        <th style={{ border: '1px solid gray', padding: '5px' }}>Medicine Name</th>
                                        <th style={{ border: '1px solid gray', padding: '5px' }}>Dose</th>
                                        <th style={{ border: '1px solid gray', padding: '5px' }}>Qty</th>
                                        <th style={{ border: '1px solid gray', padding: '5px' }}>Remark</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        medicinedata?.medicinePrint?.data?.medicines?.length > 0 ? (
                                            medicinedata.medicinePrint.data.medicines.map((res, index) => (
                                                <tr key={index}>
                                                    <td style={{ border: '1px solid gray', padding: '8px' }}>{index + 1}</td>
                                                    <td style={{ border: '1px solid gray', padding: '8px' }}>{capitalizeFirstLetter(res.medicinName)}</td>
                                                    <td style={{ border: '1px solid gray', padding: '8px' }}>{res.dose}</td>
                                                    <td style={{ border: '1px solid gray', padding: '8px' }}>{res.qty}</td>
                                                    <td style={{ border: '1px solid gray', padding: '8px' }}>{capitalizeFirstLetter(res.remark)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: 'center' }}>No any Medicine</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div
                        style={{
                            width: "25%",
                            // borderLeft: "1px solid #b78234",
                            paddingLeft: "10px",
                            fontSize: "12px",
                        }}
                    >
                        {/* <p><strong>Date:</strong> {getCurrentDate()}</p>
                        <p><strong>Wt.:</strong></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>Today's Procedure</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>Next</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>Total Cap. Remaining</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>Local</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>I.M.</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>B.P.</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>RBS</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} />
                        <p><strong>New Investigation</strong></p>
                        <p></p>
                        <hr style={{ color: "#d68000", fontWeight: "bold" }} /> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MedicineBill;
